import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import getStyles from './styles';
import Grid from '@mui/material/Grid2';
import { isEmpty } from 'lodash';
import axios from 'axios';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

export default function ContactPopup(props) {
  const { open = false, handleClose = () => {} } = props;
  const [formInput, setFormInput] = useState({});
  const [formError, setFormError] = useState({});
  const [apiStatus, setApiStatus] = useState(200);

  const { rootWraper = {}, basicInput } = getStyles();

  useEffect(() => {
    setFormError({});
  }, []);

  const handleForm = (event) => {
    const {
      target: { value = '', name = '' }
    } = event;
    const newInputs = structuredClone(formInput);
    newInputs[name] = value;
    setFormInput(newInputs);
  };

  const handleSubmitForm = async () => {
    const errorData = {};

    // Validate Email
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
    // if (!emailRegex.test(formInput.email))
    //   errorData.email = !emailRegex.test(formInput.email);

    // Validate Phone
    const phoneRegex = /^\d{10}$/; // Only digits, exactly 10 digits
    if (!phoneRegex.test(formInput.phone))
      errorData.phone = !phoneRegex.test(formInput.phone);

    // Validate Name
    if (!(formInput.username && formInput.username.length > 2))
      errorData.username = !(
        formInput.username && formInput.username.length > 2
      );
    if (!isEmpty(errorData)) {
      setFormError(errorData);
    } else {
      const emailUrl = 'https://cross-fitness.netlify.app/api/email';

      const sendMailRequest = {
        to: `info@beatxfit.com`,
        subject: `Notification - ${formInput.username} is reaching us`,
        text: `Hi, User named ${formInput.username} has tried to reaching us, Mobile number is ${formInput.phone} and email id is ${formInput.email}`
      };

      const googleFormUrl =
        'https://docs.google.com/forms/d/e/1FAIpQLSciQvAQBAm46RTDI561zOtYOTfFqGnTPquGrgacgWanIekFmg/formResponse';

      const formData = new FormData();
      formData.append('entry.34328837', formInput.username);
      formData.append('entry.483236186', formInput.email);
      formData.append('entry.1724957171', formInput.phone);
      formData.append('entry.1481026293', formInput.message ?? '');
      formData.append('entry.1917526112_year', new Date().getFullYear());
      formData.append('entry.1917526112_month', new Date().getMonth() + 1);
      formData.append('entry.1917526112_day', new Date().getDate());

      const config = {
        headers: {
          'Content-Type': 'application/json' // Default for JSON payloads
        }
      };
      setFormError({});
      const result = await axios.post(emailUrl, sendMailRequest, config);
      await fetch(googleFormUrl, {
        method: 'POST',
        body: formData,
        mode: 'no-cors' // Prevents CORS issues
      });
      if (result.status === 200) {
        handleClose();
        setApiStatus(200);
      } else {
        setApiStatus(400);
      }
    }
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={{ marginRight: '5px', p: 2, width: '90%' }}
          id="customized-dialog-title"
        >
          Start your fitness journey with us
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: -4,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid sx={{ textAlign: 'right', color: '#83827f', fontSize: '12px' }}>
            * Required
          </Grid>
          <Grid
            size={{ xs: 12 }}
            sx={{ color: 'red', fontSize: '16px', fontWeight: 'bold' }}
          >
            {apiStatus !== 200 &&
              `Failed to submit your data, reachout us from contact us sections. `}
          </Grid>
          <Grid size={{ xs: 12 }} sx={rootWraper}>
            <TextField
              sx={basicInput}
              id="outlined-required"
              name="phone"
              required
              label="Your Phone Number"
              error={formError?.phone ? true : false}
              helperText={formError?.phone ? 'Enter 10 digit phone number' : ''}
              fullWidth
              onChange={(event) => {
                handleForm(event);
              }}
            />
          </Grid>
          <Grid size={{ xs: 12 }} sx={rootWraper}>
            <TextField
              sx={basicInput}
              id="outlined-required"
              name="username"
              required
              label="Your Name"
              error={formError?.username ? true : false}
              helperText={
                formError?.username
                  ? 'Enter username greater than 2 charater'
                  : ''
              }
              fullWidth
              onChange={(event) => {
                handleForm(event);
              }}
            />
          </Grid>
          <Grid size={{ xs: 12 }} sx={rootWraper}>
            <TextField
              sx={basicInput}
              id="outlined-required"
              name="email"
              label="Your Email"
              fullWidth
              onChange={(event) => {
                handleForm(event);
              }}
            />
          </Grid>
          <Grid size={{ xs: 12 }} sx={rootWraper}>
            <TextField
              sx={basicInput}
              id="outlined-required"
              name="message"
              label="Message"
              error={false}
              helperText={formError?.username ? 'Enter your message' : ''}
              fullWidth
              multiline
              minRows={2}
              maxRows={2}
              onChange={(event) => {
                handleForm(event);
              }}
            />
          </Grid>
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              handleSubmitForm();
            }}
          >
            Submit
          </Button>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
}
